<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="700" persistent :fullscreen="x_mobile">
      <v-card>
        <v-container>
          <!-- <pre>{{location}}</pre> -->
          <v-form ref="form" @submit.prevent="save">
            <v-toolbar flat>
              <v-toolbar-title class="form-dialog-title">{{form_title}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn @click="close" icon class="float-right">
                <v-icon>mdi-window-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text :class="$vuetify.breakpoint.xsOnly?'pa-0':'py-0'">
              <v-container class="py-0">
                <v-row align="center" justify="center">
                  <v-col cols="12" class="py-0">
                    <v-btn
                      class="float-right"
                      @click="mode='edit'"
                      v-show="mode!='edit'&&edited_id>-1"
                      x-small
                      outlined
                    >
                      แก้ไข
                      <v-icon x-small class="ml-1">fas fa-pencil-alt</v-icon>
                    </v-btn>

                    <v-btn
                      class="float-right mr-2"
                      @click="deleteLocation(edited_id)"
                      v-show="mode!='edit'&&edited_id>-1"
                      x-small
                      outlined
                      color="#cb1a1a"
                    >
                      ลบข้อมูล
                      <v-icon x-small class="ml-1">far fa-trash-alt</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col
                    :cols="$vuetify.breakpoint.xsOnly?'12':'12'"
                    xs="12"
                    sm="5"
                    md="4"
                    lg="4"
                    xl="3"
                    align="center"
                    justify="center"
                  >
                    <v-card
                      tile
                      height="120px"
                      v-if="location_file_image_from_api==''&&location_file_image_upload==''"
                    >
                      <v-icon class="mt-12">mdi-image-area</v-icon>
                    </v-card>
                    <v-img
                      aspect-ratio="1.6"
                      v-if="location_file_image_from_api!=''"
                      :src="location_file_image_from_api"
                    ></v-img>
                    <v-img
                      v-show="location_file_image_upload!=''&&location_file_image_upload_show!=''"
                      :src="location_file_image_upload_show"
                      aspect-ratio="1.6"
                    />
                  </v-col>
                  <v-col
                    :class="$vuetify.breakpoint.xsOnly?'py-2':''"
                    :cols="$vuetify.breakpoint.xsOnly?'12':'12'"
                    sm="7"
                    md="8"
                    xl="9"
                    lg="8"
                  >
                    <div
                      :style="mode||edited_id<0?'background-color:#ededed;':''"
                      :class="$vuetify.breakpoint.xsOnly?'pa-1':'py-2'"
                    >
                      <v-card-title
                        :class="$vuetify.breakpoint.xsOnly?'image-title pa-1':'image-title'"
                      >
                        ภาพประกอบ
                        <span class="pl-1" style="color:red;">*</span>
                      </v-card-title>
                      <v-card-text>
                        <v-row class="pl-1">
                          <v-col
                            class="py-0"
                            :cols="extra_mobile?8:9"
                            sm="8"
                            md="9"
                            xl="9"
                            lg="9"
                            style="background:white;"
                          >
                            <v-list-item-title
                              v-if="location_file_image_name_from_api!=''"
                              class="font-kanit-light"
                            >{{location_file_image_name_from_api!=''?location_file_image_name_from_api:''}}</v-list-item-title>
                            <v-list-item-title
                              v-if="location_file_image_upload!=''"
                              class="font-kanit-light"
                            >{{location_file_image_upload_show_name!=''?location_file_image_upload_show_name:''}}</v-list-item-title>
                          </v-col>
                          <v-col class="py-0" :cols="extra_mobile?4:3" sm="4" md="3" xl="3" lg="3">
                            <v-btn
                              color="#6a6262"
                              dark
                              x-small
                              @click="ImageCropieOpen()"
                              v-show="mode=='edit'||edited_id<0"
                              block
                            >
                              <span
                                dark
                                style="font-size:12px;"
                                class="white--text font-kanit-light"
                              >เลือกรูป</span>
                            </v-btn>
                            <!-- <v-card
                              color="#6a6262"
                              class="text-center"
                              v-show="mode=='edit'||edited_id<0"
                            >
                              <label for="location_image_file">
                                <span
                                  dark
                                  style="font-size:12px;"
                                  class="white--text font-kanit-light"
                                >เลือกรูป</span>
                              </label>
                              <file-upload
                                input-id="location_image_file"
                                :directory="directory"
                                :accept="acceptphoto"
                                :extensions="extensionsphoto"
                                :size="size || 0"
                                :thread="thread < 1 ? 1 : thread > 5 ? 5 : thread"
                                :headers="headers"
                                :data="data"
                                @input-filter="inputFilter"
                                v-model="location_file_image_upload"
                                @input-file="inputFile"
                                ref="location_media"
                              ></file-upload>
                            </v-card>-->
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </div>
                  </v-col>
                  <v-row class="pa-3">
                    <v-col
                      :class="mode!='edit'&&edited_id>-1?'hide_input_line py-1':'py-1'"
                      cols="12"
                      xs="12"
                      sm="6"
                      md="6"
                      lg="6"
                      xl="6"
                    >
                      <v-text-field
                        :readonly="mode!='edit'&&edited_id>-1"
                        v-model="location.name"
                        dense
                        :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_empty"
                        label="ชื่อสาขา *"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      :class="mode!='edit'&&edited_id>-1?'hide_input_line py-1':'py-1'"
                      cols="12"
                      xs="12"
                      sm="6"
                      md="6"
                      lg="6"
                      xl="6"
                    >
                      <v-autocomplete
                        :readonly="mode!='edit'&&edited_id>-1"
                        v-model="location.province"
                        :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_empty"
                        :items="all_province"
                        class="list-item-autocomplete"
                        dense
                        label="จังหวัด *"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      :class="mode!='edit'&&edited_id>-1?'hide_input_line py-1':'py-1'"
                      cols="12"
                      xs="12"
                      sm="6"
                      md="6"
                      lg="6"
                      xl="6"
                    >
                      <v-text-field
                        :readonly="mode!='edit'&&edited_id>-1"
                        v-model="location.address"
                        dense
                        :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_empty_longtext"
                        label="ที่อยู่ *"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      :class="mode!='edit'&&edited_id>-1?'hide_input_line py-1':'py-1'"
                      cols="12"
                      xs="12"
                      sm="6"
                      md="6"
                      lg="6"
                      xl="6"
                    >
                      <v-text-field
                        :readonly="mode!='edit'&&edited_id>-1"
                        v-model="location.work_time"
                        dense
                        :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_empty"
                        label="เวลาทำการ *"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      :class="mode!='edit'&&edited_id>-1?'hide_input_line py-1':'py-1'"
                      cols="12"
                      xs="12"
                      sm="6"
                      md="6"
                      lg="6"
                      xl="6"
                    >
                      <v-text-field
                        :readonly="mode!='edit'&&edited_id>-1"
                        v-model="location.phone"
                        dense
                        v-mask="mobile_mask"
                        :rules="(mode != 'edit' && edited_id > -1)?no_rules:rules_tel"
                        label="เบอร์โทรศัพท์ *"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      :class="mode!='edit'&&edited_id>-1?'hide_input_line py-1':'py-1'"
                      cols="12"
                      xs="12"
                      sm="6"
                      md="6"
                      lg="6"
                      xl="6"
                    >
                      <v-text-field
                        :readonly="mode!='edit'&&edited_id>-1"
                        v-model="location.email"
                        dense
                        :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_email"
                        :disabled="mode!='edit'&&edited_id> -1&&location.email==''"
                        label="อีเมล"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      :class="mode!='edit'&&edited_id>-1?'hide_input_line py-1':'py-1'"
                      cols="12"
                    >
                      <v-text-field
                        :readonly="mode!='edit'&&edited_id>-1"
                        v-model="location.line_id"
                        dense
                        :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_staff_position"
                        label="Line ID"
                        :disabled="mode!='edit'&&edited_id> -1&&location.line_id==''"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      :class="mode!='edit'&&edited_id>-1?'hide_input_line py-1':'py-1'"
                      cols="12"
                    >
                      <v-text-field
                        :readonly="mode!='edit'&&edited_id>-1"
                        v-model="location.line_link"
                        dense
                        :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_location_link"
                        :disabled="mode!='edit'&&edited_id> -1&&location.line_link==''"
                        label="URL Line"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      :class="mode!='edit'&&edited_id>-1?'hide_input_line py-1':'py-1'"
                      cols="12"
                    >
                      <v-text-field
                        :readonly="mode!='edit'&&edited_id>-1"
                        v-model="location.facebook"
                        dense
                        :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_staff_position"
                        :disabled="mode!='edit'&&edited_id> -1&&location.facebook==''"
                        label="Facebook"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      :class="mode!='edit'&&edited_id>-1?'hide_input_line py-1':'py-1'"
                      cols="12"
                    >
                      <v-text-field
                        :readonly="mode!='edit'&&edited_id>-1"
                        v-model="location.facebook_link"
                        dense
                        :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_location_link"
                        :disabled="mode!='edit'&&edited_id> -1&&location.facebook_link==''"
                        label="URL Facebook"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      :class="mode!='edit'&&edited_id>-1?'hide_input_line py-1':'py-1'"
                      cols="12"
                    >
                      <v-text-field
                        :readonly="mode!='edit'&&edited_id>-1"
                        v-model="location.map"
                        dense
                        :rules="(mode != 'edit' && edited_id > -1)?no_rules:rule_empty_link"
                        label="URL แผนที่ *"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions :class="$vuetify.breakpoint.xsOnly?'px-3 py-0 pb-6':'py-0 px-8 pb-6'">
              <v-spacer></v-spacer>
              <v-btn
                @click="canCel()"
                color="secondary"
                small
                outlined
                v-show="edited_id!=-1&&mode=='edit'"
              >ยกเลิก</v-btn>
              <v-btn
                color="button"
                v-show="edited_id==-1||mode=='edit'"
                dark
                :loading="btn_loading"
                type="submit"
                small
              >บันทึก</v-btn>
            </v-card-actions>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>

    <CropImg
      ref="crop_image"
      @profileImg="setEmitProfileImg"
      @profileImgShow="setEmitProfileImgShow"
      @image_crop_name="setImageCropName"
    ></CropImg>
  </v-container>
</template>
<script>
import { mask } from "vue-the-mask";

import { rules } from "../assets/js/validate";
import hljs from "highlight.js";
import FileUpload from "vue-upload-component";
import CropImg from "../components/CropImg";
export default {
  components: {
    FileUpload,
    CropImg,
  },
  directives: {
    mask,
  },
  data() {
    return {
      header_token: { headers: { token: this.$session.get("token") } },
      btn_loading: false,
      // mask
      mobile_mask: "###-###-####",
      all_province: [],
      profile: [],
      dialog: false,
      edited_id: -1,
      rule_empty: rules.empty,
      rules_tel: rules.tel_rules,
      rule_email: rules.location_email_rules,
      rule_empty_link: rules.empty_link,
      rule_empty_longtext: rules.empty_longtext,
      rule_staff_position: rules.staff_position_rules,
      rule_location_link: rules.location_link_rules,
      no_rules: [],
      mode: "",
      // location_file_image_upload: [],
      //image
      location_file_image_upload: "",
      location_file_image_upload_show: "",
      location_file_image_upload_show_name: "",
      status_mode_crop: "",
      location_file_image_name_from_api: "",
      old_location_file_image_name_from_api: "",
      location_file_image_from_api: "",
      old_location_file_image_from_api: "",
      location: {
        image_id: "",
        name: "",
        work_time: "",
        address: "",
        province: "",
        map: "",
        phone: "",
        email: "",
        line_id: "",
        line_link: "",
        facebook: "",
        facebook_link: "",
        update_by: "",
      },
      old_location: {},
      // image
      minSize: "",
      size: "",
      acceptphoto: "image/png,image/gif,image/jpeg,image/jpg", //,video/mp4,video/x-m4v,video/*
      extensionsphoto: "gif,jpg,jpeg,png",
      directory: false,
      thread: 3,
      postAction: "/upload/post",
      headers: {
        "X-Csrf-Token": "xxxx",
      },
      data: {
        _csrf_token: "xxxxxx",
      },
      autoCompress: "",
      uploadAuto: true,
    };
  },

  computed: {
    form_title() {
      return this.edited_id == -1
        ? "เพิ่มสาขา"
        : this.edited_id != -1 && this.mode == "edit"
        ? "แก้ไขสาขา"
        : "รายละเอียดสาขา";
    },
    x_mobile() {
      if (this.$vuetify.breakpoint.width <= 415) {
        return true;
      } else {
        return false;
      }
    },
    extra_mobile() {
      if (this.$vuetify.breakpoint.width <= 370) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    mode(val) {
      if (val != "edit" && this.edited_id != -1) {
        setTimeout(() => {
          this.$refs.form.resetValidation();
        }, 100);
      } else if (val == "edit") {
        setTimeout(() => {
          this.$refs.form.validate();
        }, 50);
      }
    },

    // "location.line_id"(val) {
    //   console.log(val);
    //   if (this.location.line_link == "" && this.edited_id < 0) {
    //     setTimeout(() => {
    //       this.location.line_link = "http://line.me/ti/p/~" + val;
    //     }, 3000);
    //   }
    // },
  },
  created() {
    this.getProvince();
  },
  methods: {
    getProvince() {
      let province = [];
      this.all_province = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/province", this.header_token)
        .then((response) => {
          // console.log(response.data.result);
          province = response.data.result.name;
          if (response.data.result.name && response.data.status == "OK") {
            this.all_province = province;
          }
        });
    },
    ImageCropieOpen() {
      this.$refs.crop_image.open(this.status_mode_crop);
    },
    open(item) {
      this.status_mode_crop = "add";
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 100);
      // console.log(item);
      if (item != "") {
        if (item.locat_id >= 0) {
          this.edited_id = item.locat_id;
          this.mode = "";

          this.location = {
            image_id: item.image.image_id,
            name: item.name,
            work_time: item.work_time,
            address: item.address,
            province: item.province,
            map: item.map,
            phone: item.phone,
            email: item.email == null ? "" : item.email,
            line_id: item.line_id == null ? "" : item.line_id,
            line_link: item.line_link == null ? "" : item.line_link,
            facebook: item.facebook == null ? "" : item.facebook,
            facebook_link: item.facebook_link == null ? "" : item.facebook_link,
            update_by: "",
          };
          this.old_location = {
            old_image_id: item.image.image_id,
            old_name: item.name,
            old_work_time: item.work_time,
            old_address: item.address,
            old_province: item.province,
            old_map: item.map,
            old_phone: item.phone,
            old_email: item.email == null ? "" : item.email,
            old_line_id: item.line_id == null ? "" : item.line_id,
            old_line_link: item.line_link == null ? "" : item.line_link,
            old_facebook: item.facebook == null ? "" : item.facebook,
            old_facebook_link:
              item.facebook_link == null ? "" : item.facebook_link,
          };
          this.location_file_image_from_api = item.image_path_by_id;
          this.old_location_file_image_from_api = item.image_path_by_id;
          this.location_file_image_name_from_api = item.image.filename;
          this.old_location_file_image_name_from_api = item.image.filename;
        }
      } else {
        this.edited_id = -1;
        this.mode = "";
        this.location = {
          image_id: "",
          name: "",
          work_time: "",
          address: "",
          province: "",
          map: "",
          phone: "",
          email: "",
          line_id: "",
          line_link: "",
          facebook: "",
          facebook_link: "",
          update_by: "",
        };
      }
      this.dialog = true;
    },
    // image
    // inputFile(newFile) {
    //   this.location_file_image_name_from_api = "";
    //   this.location_file_image_from_api = "";
    // },
    // inputFilter(newFile, oldFile, prevent) {
    //   if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
    //     newFile.blob = "";
    //     let URL = window.URL || window.webkitURL;
    //     if (URL && URL.createObjectURL) {
    //       newFile.blob = URL.createObjectURL(newFile.file);
    //     }
    //     newFile.thumb = "";
    //     if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
    //       newFile.thumb = newFile.blob;
    //     }
    //   }
    // },
    close() {
      this.location = {
        image_id: "",
        name: "",
        work_time: "",
        address: "",
        province: "",
        map: "",
        phone: "",
        email: "",
        line_id: "",
        line_link: "",
        facebook: "",
        facebook_link: "",
        update_by: "",
      };

      this.location_file_image_from_api = "";
      this.location_file_image_name_from_api = "";
      // this.$refs.location_media.remove(this.location_file_image_upload[0]);
      // this.location_file_image_upload = [];
      this.location_file_image_upload = "";
      this.location_file_image_upload_show = "";
      this.location_file_image_upload_show_name = "";
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 50);
      this.edited_id = -1;
      this.mode = "";
      this.btn_loading = false;
      this.dialog = false;
    },
    canCel() {
      this.location = {
        image_id: this.old_location.old_image_id,
        name: this.old_location.old_name,
        work_time: this.old_location.old_work_time,
        address: this.old_location.old_address,
        province: this.old_location.old_province,
        map: this.old_location.old_map,
        phone: this.old_location.old_phone,
        email: this.old_location.old_email,
        line_id: this.old_location.old_line_id,
        line_link: this.old_location.old_line_link,
        facebook: this.old_location.old_facebook,
        facebook_link: this.old_location.old_facebook_link,
        update_by: "",
      };
      // this.$refs.location_media.remove(this.location_file_image_upload[0]);
      // this.location_file_image_upload = [];
      this.location_file_image_upload = "";
      this.location_file_image_upload_show = "";
      this.location_file_image_upload_show_name = "";

      this.location_file_image_from_api = this.old_location_file_image_from_api;
      this.location_file_image_name_from_api = this.old_location_file_image_name_from_api;

      this.mode = "";
    },
    deleteLocation(id) {
      // console.log(id);
      this.$swal
        .fire({
          text: "ท่านต้องการยืนยันการลบหรือไม่?",
          // text: "ข้อมูลจะถูกลบทันทีเมื่อกด 'ยืนยัน' ยกเลิกรายการกด 'ยกเลิก'",
          icon: "warning",
          width: 500,
          showCancelButton: true,
          confirmButtonColor: "#E53935",
          cancelButtonColor: "#9E9E9E",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        })
        .then((res) => {
          if (res.value) {
            this.axios
              .delete(
                process.env.VUE_APP_API + "/api/v1/location/" + id,
                this.header_token
              )
              .then((response) => {
                // console.log(response.data.result);
                if (
                  response.data.status == "OK" &&
                  response.data.status != "FAIL"
                ) {
                  this.$swal.fire({
                    icon: "success",
                    width: 500,
                    title: response.data.message,
                    text: "ดำเนินการลบข้อมูลเรียบร้อยแล้ว",
                    showConfirmButton: false,
                    timer: 2000,
                    showCloseButton: true,
                  });
                  this.$emit("getlocation", "delete");
                  this.close();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    width: 500,
                    title: response.data.message,
                    text: "ไม่สามารถลบข้อมูลได้",
                    showConfirmButton: false,
                    timer: 2000,
                    showCloseButton: true,
                  });
                }
              })
              .catch((err) => {
                this.$swal.fire({
                  icon: "error",
                  width: 500,
                  title: "เกิดข้อผิดพลาด",
                  showConfirmButton: false,
                  timer: 2000,
                  showCloseButton: true,
                });
              });
          }
        });
    },
    save() {
      this.profile = this.$session.get("profile");
      if (this.$refs.form.validate()) {
        if (this.edited_id > -1) {
          this.putLocation(this.edited_id);
        } else {
          this.postLocation();
        }
      }
    },
    postLocation() {
      if (
        this.location_file_image_upload != "" &&
        this.location_file_image_upload.length != 0
      ) {
        if (this.location_file_image_upload_show_name.length < 50) {
          this.btn_loading = true;
          let data = {};
          let form = new FormData();
          form.append(
            "file",
            this.location_file_image_upload,
            this.location_file_image_upload_show_name
          );
          this.axios
            .post(
              process.env.VUE_APP_API + "/api/v1/image/",
              form,
              this.header_token
            )
            .then((response) => {
              // console.log(response.data);
              if (response.data.result.image_id) {
                let image_id = response.data.result.image_id;
                data = this.location;
                data.email == "" ? (data.email = null) : data.email;
                data.line_id == "" ? (data.line_id = null) : data.line_id;
                data.line_link == "" ? (data.line_link = null) : data.line_link;
                data.facebook == "" ? (data.facebook = null) : data.facebook;
                data.facebook_link == ""
                  ? (data.facebook_link = null)
                  : data.facebook_link;
                data.image_id = image_id;
                data.update_by = this.profile.staff_id;
                // console.log(data);
                this.axios
                  .post(
                    process.env.VUE_APP_API + "/api/v1/location",
                    data,
                    this.header_token
                  )
                  .then((response) => {
                    // console.log(response.data.result);
                    if (
                      response.data.status == "OK" &&
                      response.data.status != "FAIL"
                    ) {
                      this.$swal.fire({
                        icon: "success",
                        width: 500,
                        title: response.data.message,
                        text: " ดำเนินการบันทึกข้อมูลเรียบร้อยแล้ว",
                        showConfirmButton: false,
                        timer: 2000,
                        showCloseButton: true,
                      });
                      this.$emit("getlocation", "add");
                      this.close();
                    } else {
                      this.$swal.fire({
                        icon: "error",
                        width: 500,
                        title: response.data.message,
                        text: " กรุณาตรวจสอบข้อมูลของท่าน",
                        showConfirmButton: false,
                        timer: 2000,
                        showCloseButton: true,
                      });
                      this.close();
                    }
                  });
              }
            })
            .catch((err) => {
              this.$swal.fire({
                icon: "error",
                width: 500,
                title: "เกิดข้อผิดพลาด",
                showConfirmButton: false,
                timer: 2000,
                showCloseButton: true,
              });
            });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "ชื่อไฟล์ยาวเกินไป",
            text: "กรุณาเปลี่ยนชื่อไฟล์ให้มีความยาวน้อยกว่า 45 ตัว",
            showConfirmButton: false,
            timer: 1200,
            showCloseButton: true,
          });
        }
      } else {
        this.$swal.fire({
          icon: "error",
          title: "กรุณาตรวจสอบภาพ",
          showConfirmButton: false,
          timer: 2000,
          showCloseButton: true,
        });
      }
    },
    putLocation(id) {
      let data = {};
      let form = new FormData();
      if (
        this.location_file_image_name_from_api != "" ||
        this.location_file_image_from_api != ""
      ) {
        this.btn_loading = true;
        data = this.location;
        data.email == "" ? (data.email = null) : data.email;
        data.line_id == "" ? (data.line_id = null) : data.line_id;
        data.line_link == "" ? (data.line_link = null) : data.line_link;
        data.facebook == "" ? (data.facebook = null) : data.facebook;
        data.facebook_link == ""
          ? (data.facebook_link = null)
          : data.facebook_link;
        data.update_by = this.profile.staff_id;
        // console.log(data);
        this.axios
          .put(
            process.env.VUE_APP_API + "/api/v1/location/" + id,
            data,
            this.header_token
          )
          .then((response) => {
            if (
              response.data.status == "OK" &&
              response.data.status != "FAIL"
            ) {
              this.$swal.fire({
                icon: "success",
                width: 500,
                title: response.data.message,
                text: " ดำเนินการบันทึกข้อมูลเรียบร้อยแล้ว",
                showConfirmButton: false,
                timer: 2000,
                showCloseButton: true,
              });
              this.$emit("getlocation", "edit");
              this.close();
            } else {
              this.$swal.fire({
                icon: "error",
                width: 500,
                title: response.data.message,
                text: " กรุณาตรวจสอบข้อมูลของท่าน",
                showConfirmButton: false,
                timer: 2000,
                showCloseButton: true,
              });
              this.close();
            }
          })
          .catch((err) => {
            this.$swal.fire({
              icon: "error",
              width: 500,
              title: "เกิดข้อผิดพลาด",
              showConfirmButton: false,
              timer: 2000,
              showCloseButton: true,
            });
          });
      } else if (
        this.location_file_image_upload != "" &&
        this.location_file_image_upload.length != 0
      ) {
        if (this.location_file_image_upload_show_name.length < 50) {
          this.btn_loading = true;
          form = new FormData();
          form.append(
            "file",
            this.location_file_image_upload,
            this.location_file_image_upload_show_name
          );
          this.axios
            .post(
              process.env.VUE_APP_API + "/api/v1/image/",
              form,
              this.header_token
            )
            .then((response) => {
              // console.log(response.data);
              if (response.data.result.image_id) {
                let image_id = response.data.result.image_id;
                data = this.location;
                data.email == "" ? (data.email = null) : data.email;
                data.line_id == "" ? (data.line_id = null) : data.line_id;
                data.line_link == "" ? (data.line_link = null) : data.line_link;
                data.facebook == "" ? (data.facebook = null) : data.facebook;
                data.facebook_link == ""
                  ? (data.facebook_link = null)
                  : data.facebook_link;
                data.image_id = image_id;
                data.update_by = this.profile.staff_id;
                // console.log(data);
                this.axios
                  .put(
                    process.env.VUE_APP_API + "/api/v1/location/" + id,
                    data,
                    this.header_token
                  )
                  .then((response) => {
                    if (
                      response.data.status == "OK" &&
                      response.data.status != "FAIL"
                    ) {
                      this.$swal.fire({
                        icon: "success",
                        width: 500,
                        title: response.data.message,
                        text: " ดำเนินการบันทึกข้อมูลเรียบร้อยแล้ว",
                        showConfirmButton: false,
                        timer: 2000,
                        showCloseButton: true,
                      });
                      this.$emit("getlocation", "edit");
                      this.close();
                    } else {
                      this.$swal.fire({
                        icon: "error",
                        width: 500,
                        title: response.data.message,
                        text: " กรุณาตรวจสอบข้อมูลของท่าน",
                        showConfirmButton: false,
                        timer: 2000,
                        showCloseButton: true,
                      });
                      this.close();
                    }
                  });
              }
            })
            .catch((err) => {
              this.$swal.fire({
                icon: "error",
                width: 500,
                title: "เกิดข้อผิดพลาด",
                showConfirmButton: false,
                timer: 2000,
                showCloseButton: true,
              });
            });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "ชื่อไฟล์ยาวเกินไป",
            text: "กรุณาเปลี่ยนชื่อไฟล์ให้มีความยาวน้อยกว่า 45 ตัว",
            showConfirmButton: false,
            timer: 1200,
            showCloseButton: true,
          });
        }
      } else {
        this.$swal.fire({
          icon: "error",
          title: "กรุณาตรวจสอบภาพ",
          showConfirmButton: false,
          timer: 2000,
          showCloseButton: true,
        });
      }
    },
    setEmitProfileImg(value) {
      this.location_file_image_from_api = "";
      this.location_file_image_name_from_api = "";
      this.image_path_by_id = "";
      // console.log(value);
      this.location_file_image_upload = value;
      // this.dataProfileImg.append("file", value);
      // this.checkEmitProfileImg();
    },
    setEmitProfileImgShow(value) {
      this.status_mode_crop = "";
      if (value == "delete") {
        this.image_crop_delete = "delete";
        this.location_file_image_upload_show = "";
      } else {
        // console.log(value);
        this.location_file_image_upload_show = value;
      }

      // this.image = value;
      // this.checkEmitProfileImg();
    },
    setImageCropName(value) {
      // console.log(value);
      this.location_file_image_upload_show_name = value;
    },
  },
};
</script>